
import Card from "@/components/base/card/Card"

export default {
    name: "RegionCenter",
    components: { Card },
    props: {
        /** Full region object */
        region: {
            type: Object,
            default: () => ({}),
        },
    },
    data: () => ({
        locations: [
            {
                img: [
                    "linear-gradient(#00000055, #00000055)",
                    require("@/assets/images/region/passau/cities/passau.jpg"),
                ],
                title: "Passau",
                alt: "Passau",
                route: "/ausbildung/passau-2855328?distance=10&latitude=48.5665&longitude=13.43122",
            },
            {
                img: [
                    "linear-gradient(#00000055, #00000055)",
                    require("@/assets/images/region/passau/cities/vilshofen.jpg"),
                ],
                title: "Vilshofen",
                alt: "Vilshofen",
                route: "/ausbildung/vilshofen-an-der-donau-2817202?distance=10&latitude=48.62695&longitude=13.19222",
            },
            {
                img: [
                    "linear-gradient(#00000055, #00000055)",
                    require("@/assets/images/region/passau/cities/hauzenberg.jpg"),
                ],
                title: "Hauzenberg",
                alt: "Hauzenberg",
                route: "/ausbildung/hauzenberg-2908661?distance=10&latitude=48.64957&longitude=13.62645",
            },
            {
                img: [
                    "linear-gradient(#00000055, #00000055)",
                    require("@/assets/images/region/passau/cities/fuerstenstein.jpg"),
                ],
                title: "Fürstenstein",
                alt: "Fürstenstein",
                route: "/ausbildung/furstenstein-2923595?distance=10&latitude=48.71667&longitude=13.33333",
            },
            {
                img: [
                    "linear-gradient(#00000055, #00000055)",
                    require("@/assets/images/region/passau/cities/bad_griesbach.jpg"),
                ],
                title: "Bad Griesbach",
                alt: "Bad Griesbach",
                route: "/ausbildung/bad-griesbach-im-rottal-2917461?distance=10&latitude=48.45181&longitude=13.19329",
            },
            {
                img: [
                    "linear-gradient(#00000055, #00000055)",
                    require("@/assets/images/region/passau/cities/untergriesbach.jpg"),
                ],
                title: "Untergriesbach",
                alt: "Untergriesbach",
                route: "/ausbildung/untergriesbach-2819497?distance=10&latitude=48.57434&longitude=13.66725",
            },
        ],
    }),
    computed: {
        seoContentText() {
            return this.region?.about_us
        },
    },
}
